import React from 'react';
import { PROGRAMS } from '../data/config';

// ── WHAT WE DO ────────────────────────────────────────────────
// Edit the cards by updating PROGRAMS in src/data/config.js
const WHAT_WE_DO = [
  {
    icon: '🚀',
    title: 'Professional Development',
    description: 'Resume workshops, mock interviews, and corporate networking events to prepare you for internships and full-time roles.',
    color: '#E5751F',
  },
  {
    icon: '🤝',
    title: 'Community & Culture',
    description: 'A tight-knit family that supports you academically and personally. Socials, study groups, and cultural celebrations.',
    color: '#861F41',
  },
  {
    icon: '🌱',
    title: 'STEM Outreach',
    description: 'Inspiring K-12 students through hands-on activities, school visits, and mentorship to close the opportunity gap in STEM.',
    color: '#2D7A4F',
  },
  {
    icon: '🎓',
    title: 'Conferences',
    description: 'Attend SHPE NLC and regional conferences to meet hundreds of engineers and recruiters from top companies.',
    color: '#1A4A7A',
  },
];

export default function WhatWeDo() {
  return (
    <section style={{
      padding: '80px 24px',
      background: 'white',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="section-header">
          <span className="section-label">What We Do</span>
          <h2 className="section-title">Four Pillars of SHPE@VT</h2>
          <p className="section-subtitle">
            Everything we do is rooted in preparing Hokies to thrive in STEM — professionally, academically, and as community leaders.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: 24,
        }}>
          {WHAT_WE_DO.map((item, i) => (
            <div key={i} className="card" style={{
              padding: 32,
              borderTop: `4px solid ${item.color}`,
              position: 'relative', overflow: 'hidden',
            }}>
              {/* Background decoration */}
              <div style={{
                position: 'absolute', top: -20, right: -20,
                width: 100, height: 100, borderRadius: '50%',
                background: `${item.color}10`,
                pointerEvents: 'none',
              }} />

              <div style={{
                width: 56, height: 56, borderRadius: 14,
                background: `${item.color}15`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 26, marginBottom: 20,
              }}>
                {item.icon}
              </div>

              <h3 style={{
                fontFamily: 'Playfair Display, serif',
                fontSize: 20, fontWeight: 700,
                marginBottom: 12, color: '#1A1A1A',
              }}>
                {item.title}
              </h3>

              <p style={{ fontSize: 14, color: '#666', lineHeight: 1.7 }}>
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Why Join SHPE section */}
        <div style={{
          marginTop: 60, padding: 48,
          background: 'linear-gradient(135deg, #861F41 0%, #5C1429 100%)',
          borderRadius: 20, color: 'white',
          display: 'grid', gridTemplateColumns: '1fr 1fr',
          gap: 40, alignItems: 'center',
        }} className="why-join-grid">
          <div>
            <span style={{ fontSize: 12, letterSpacing: 3, textTransform: 'uppercase', color: '#F59142', fontWeight: 700 }}>
              Why Join
            </span>
            <h2 style={{
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(1.8rem, 3vw, 2.5rem)',
              fontWeight: 900, marginTop: 8, marginBottom: 16,
            }}>Why Join SHPE@VT?</h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.7 }}>
              SHPE at Virginia Tech is a student-led organization dedicated to empowering the next generation of Hispanic engineers and scientists through professional development, academic excellence, and community impact. We build leaders who succeed in college, careers, and beyond.
            </p>
          </div>

          {/* Benefits list — UPDATE these bullet points as needed */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {[
              { icon: '🚀', text: 'Career readiness through workshops and conferences' },
              { icon: '🤝', text: 'A tight-knit community that supports you academically and personally' },
              { icon: '🌎', text: 'Opportunities to give back through STEM outreach' },
              { icon: '💼', text: 'Direct access to recruiters and industry leaders' },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
                <span style={{
                  width: 36, height: 36, borderRadius: 10,
                  background: 'rgba(229,117,31,0.25)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 18, flexShrink: 0,
                }}>
                  {item.icon}
                </span>
                <span style={{ color: 'rgba(255,255,255,0.9)', fontSize: 15, lineHeight: 1.5, paddingTop: 7 }}>
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .why-join-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
